import {
  FeedKey,
  Group,
  GroupRole,
  PublicUserProfile,
  PublicUserProfileFragment,
  UnfollowMutation,
  UserProfile,
} from 'api';
import { NULL } from 'constants/index';

interface IUnfollowResponse {
  type: FeedKey;
  currentUser: UserProfile | PublicUserProfile | PublicUserProfileFragment;
  source: Group | PublicUserProfile;
}

export const unfollowResponse = ({
  type,
  source,
  currentUser,
}: IUnfollowResponse): UnfollowMutation => {
  const nullType = type === FeedKey.User ? 'group' : 'user';

  return {
    unfollow: {
      created_at: -1,
      [nullType]: NULL,
      [type]: source,
      feed: type,
      postable: false,
      required: false,
      group_role: GroupRole.Member,
      followed_by_user: NULL,
      user_id: currentUser.id,
      // @ts-ignore
      __typename: 'UserFeedFollow',
    },
  };
};
